import { Localizable } from '@components/localizable/Localizable'
import { ProgramComplementaryItem } from '@models/membership/ProgramComplementaryItem'
import { selectComplementaryItemById } from '@store/balance/ComplementaryItemReducer'
import { useAppSelector } from '@store/hooks'
import { selectMembershipProfileComplementaryItemById } from '@store/membership/MembershipProfileComplementaryItemReducer'
import { selectProgramComplementaryItemById } from '@store/membership/ProgramComplementaryItemReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { numberRule, requiredRule } from '@utils/rules'
import { Form, InputNumber, Typography } from 'antd'
import { FC, useEffect } from 'react'

const { Text } = Typography

type Props = SBModelComponent<ProgramComplementaryItem> & {
  entity: 'program' | 'membershipProfile'
}

const selector = {
  program: selectProgramComplementaryItemById,
  membershipProfile: selectMembershipProfileComplementaryItemById,
}

const ComplementaryItemSpinner: FC<Props> = ({ entity, id, model }) => {
  const item = model ?? useAppSelector(selector[entity](id!))
  const complementaryItem = useAppSelector(
    selectComplementaryItemById(item?.complementaryItem!)
  )

  const form = Form.useFormInstance()

  if (!item || !complementaryItem) {
    return <></>
  }

  useEffect(() => {
    form.setFieldsValue({
      quantity: {
        [item.id]: item.quantity,
      },
    })
  }, [item, form])

  return (
    <Form.Item
      label={
        <Localizable.Render
          item={complementaryItem}
          render={(localizedItem, lang) => (
            <Text>
              {lang.flag} {localizedItem.name}
            </Text>
          )}
        />
      }
      name={['quantity', item.id]}
      rules={[requiredRule(), numberRule()]}
    >
      <InputNumber mode="spinner" className="w-full" />
    </Form.Item>
  )
}

type ComplementaryItemSpinnerType = { Spinner: typeof ComplementaryItemSpinner }

export { ComplementaryItemSpinner, type ComplementaryItemSpinnerType }
